enum LanguageCode {
    NL = 'nl',
    EN = 'en',
}

export const languageCodes: Array<LanguageCode> = [
    LanguageCode.NL,
    LanguageCode.EN,
];

export default LanguageCode;
